import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Table, List, Icon, Button, Header } from 'semantic-ui-react';
import i18next from 'i18next';

import { formatPrice } from '../../../../../helpers/format';

import './DeliveriesListItem.scss';

class DeliveriesListItem extends Component {

    constructor(props) {
        super(props);
    }

    renderListItemActions() {
        const { area, areActionsDisabled, editDeliveryArea, removeDeliveryArea } = this.props;

        return (
            <List.Content floated='right'>
                <Button color='yellow' icon labelPosition='left'
                    disabled={areActionsDisabled}
                    onClick={() => editDeliveryArea(area.tag)}>
                    {i18next.t('edit')}
                    <Icon name='edit' />
                </Button>
                <Button negative icon labelPosition='left'
                    disabled={areActionsDisabled}
                    onClick={() => removeDeliveryArea(area.tag)}>
                    {i18next.t('delete')}
                    <Icon name='trash' />
                </Button>
            </List.Content>

        );
    }

    renderListItemData() {
        const { area, currencyCode } = this.props;

        return (
            <List.Content>
                <Header className='pi-deliveries-list-item-header'>{area.tag}</Header>
                <Table basic='very' color='teal' verticalAlign='middle' celled collapsing definition>
                    <Table.Body>
                        <Table.Row>
                            <Table.Cell>{i18next.t('estimatedDeliveryTime')}</Table.Cell>
                            <Table.Cell>{area.estimatedTime}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                            <Table.Cell>{i18next.t('deliveryOrderFee')}</Table.Cell>
                            <Table.Cell>{formatPrice(area.orderFee, currencyCode)}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                            <Table.Cell>{i18next.t('minimumDeliveryOrderPrice')}</Table.Cell>
                            <Table.Cell>{formatPrice(area.minimumOrderPrice, currencyCode)}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                            <Table.Cell>{i18next.t('minimumCompanyDeliveryOrderPrice')}</Table.Cell>
                            <Table.Cell>{area.companyMinimumOrderPrice ?
                                formatPrice(area.companyMinimumOrderPrice, currencyCode) : null
                            }</Table.Cell>
                        </Table.Row>
                    </Table.Body>
                </Table>
            </List.Content>
        );
    }

    render() {
        return (
            <List.Item className='pi-deliveries-list-item'>
                {this.renderListItemActions()}
                {this.renderListItemData()}
            </List.Item>
        );
    }

}

DeliveriesListItem.propTypes = {
    areActionsDisabled: PropTypes.bool,
    area: PropTypes.object,
    currencyCode: PropTypes.string,
    editDeliveryArea: PropTypes.func,
    removeDeliveryArea: PropTypes.func,
    
};

export default DeliveriesListItem;
